import React, { useMemo } from 'react';
import { View, StyleSheet, type ViewStyle, type StyleProp } from 'react-native';
import type { ThemeColors } from '../../../../shared/theme';
import { DASH_STUDIO_INNER, DASH_STUDIO_RADIUS } from '../../../../shared/theme/studio/dashboardConstants';
import { dashboardSet2CardShell } from './dashboardSet2Styles';

export interface DashboardCardShellSet2Props {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** When true, no padding (e.g. for scroll/grid content that needs edge-to-edge). */
  no_padding?: boolean;
  colors: ThemeColors;
}

/** v2 dashboard card shell — studio radius, soft shadow, dark-mode surface. */
export function DashboardCardShellSet2({ children, style, no_padding, colors }: DashboardCardShellSet2Props) {
  const shell = useMemo(() => dashboardSet2CardShell(colors), [colors]);

  return (
    <View style={[shell, !no_padding && styles.padded, style]}>
      <View style={styles.inner}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  padded: {
    padding: DASH_STUDIO_INNER,
  },
  inner: {
    flex: 1,
    borderRadius: DASH_STUDIO_RADIUS,
    overflow: 'visible',
  },
});
